import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';

export default function TermsConditions() {
    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm overflow-hidden">
                <div className="p-8">
                    <Link to="/" className="inline-flex items-center text-sm text-blue-600 hover:text-blue-800 mb-8 transition-colors">
                        <ChevronLeft size={16} className="mr-1" />
                        Back to Login
                    </Link>

                    <h1 className="text-3xl font-bold text-gray-900 mb-6 font-display">Terms & Conditions</h1>
                    <p className="text-sm text-gray-500 mb-8 border-b pb-4">Last Updated: March 08, 2026</p>

                    <div className="prose prose-blue prose-sm max-w-none text-gray-600 space-y-6">
                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Acceptance of Terms</h2>
                            <p>By accessing and using MindConnect ("the Platform"), operated by NeuralLoom Labs Private Limited ("NeuralLoom Labs"),, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, you must not use the Platform.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Description of Service</h2>
                            <p>MindConnect is a platform for therapy session evaluation, clinical signal extraction, and supervisory review. The Platform uses advanced AI technology to assist clinicians and supervisors in standardising review processes.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Professional Disclaimer</h2>
                            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 my-4 italic">
                                The Platform is a tool to assist in clinical evaluation and should not replace professional judgement. All AI-generated outputs must be reviewed and verified by qualified supervisors or clinicians.
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Data Ownership & Use</h2>
                            <p>All therapy session data and evaluations remain the property of the respective healthcare providers or organisations. By using the Platform, you grant NeuralLoom Labs the right to process this data solely for providing the requested services.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. User Requirements</h2>
                            <p>Users must be licensed healthcare professionals or authorized administrative staff. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Confidentiality and HIPAA</h2>
                            <p>The Platform is designed to comply with standard healthcare data protection regulations. Users are responsible for ensuring that all data uploaded to the Platform is handled in accordance with their local jurisdiction's privacy laws and institutional policies.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Limitation of Liability</h2>
                            <p>NeuralLoom Labs shall not be liable for any clinical decisions made based on Platform outputs. Our liability is limited to the functionality of the software as a processing tool.</p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Changes to Terms</h2>
                            <p>We reserve the right to modify these terms at any time. Continued use of the Platform after changes are posted constitutes acceptance of the new terms.</p>
                        </section>

                        <section className="pt-8 border-t">
                            <p className="text-xs text-center text-gray-400">© 2026 NeuralLoom Labs Private Limited. All rights reserved.</p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}
